import React, { useState, useEffect } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from '../firebase';
import MinimalistLoginPage from './MinimalistLoginPage';
import ModernAdminDashboard from './ModernAdminDashboard';

interface AdminPageProps {
  t: any;
  isRTL: boolean;
}

const AdminPage: React.FC<AdminPageProps> = ({ t, isRTL }) => {
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
      if (user) {
        console.log('✅ User authenticated:', user.email);
      } else {
        console.log('ℹ️ No user authenticated');
      }
    });

    return () => unsubscribe();
  }, []);

  const handleAuthSuccess = (user: any) => {
    console.log('✅ Authentication successful:', user.email);
    setUser(user);
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setUser(null);
      console.log('✅ Logout successful');
    } catch (error) {
      console.error('❌ Logout error:', error);
    }
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '1.2rem',
        color: '#dc2626'
      }}>
        Loading...
      </div>
    );
  }

  if (!user) {
    return <MinimalistLoginPage t={t} isRTL={isRTL} onLoginSuccess={handleAuthSuccess} />;
  }

  return <ModernAdminDashboard t={t} isRTL={isRTL} onLogout={handleLogout} />;
};

export default AdminPage;
